import {
    API_RESULT_FIELDS_TO_EXPORT,
    ERROR_MESSAGE,
    buildCompanyFilename,
} from './constants';
import { useSelector } from 'react-redux';
import { axios } from 'services/axios';
import { downloadCSV } from 'utils/utils';
import { useCallback, useState } from 'react';
import Papa from 'papaparse';
import Cookies from 'js-cookie';

import useGetCurrentCompany from '@/queries/company/useGetCurrentCompany';
export default function useCSVNumbersBulkUpdate() {
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(false);
    const [succeed, setSucceed] = useState([]);
    const [counter, setCounter] = useState(0);
    const [errorCounter, setErrorCounter] = useState(0);
    const [uploadPayloads, setUploadPayloads] = useState([]);
    const { currentCompany: companyID } = useSelector(
        (state) => state.navigationLists,
    );
    const { data: currentCompanyData } = useGetCurrentCompany();

    //entry point to start API call
    const processSubmission = async (payloads) => {
        setLoading(true);
        // const finalPayloads = transformSubmitData(payloads);
        handleBulkUpdate(payloads);
    };

    //after API calls, set UI State
    const handleFinishBulkUpdate = ({ errors, responses }) => {
        console.log('handleFinishBulkUpdate called');
        console.log('Number of errors:', errors.length);
        console.log('Number of responses:', responses.length);
        console.log('Final errors:', errors);
        console.log('Final responses:', responses);

        // Log each error to see if platform exists
        errors.forEach((err, i) => {
            console.log(`Error ${i} platform:`, err.platform);
        });

        // Log each response to see if platform exists
        responses.forEach((resp, i) => {
            console.log(`Response ${i} platform:`, resp.data?.platform);
        });

        setError(errors);
        setSucceed(responses);
    };

    //handle api calls
    const handleBulkUpdate = async (payloads) => {
        console.log('=== handleBulkUpdate START ===');
        console.log('Payloads received:', payloads);
        console.log('Number of payloads:', payloads.length);

        const errors = [];
        const responses = [];
        setUploadPayloads(payloads);

        // Check if we're in Priority mode (before cookies are removed)
        const selectedPlatformName = Cookies.get('selectedPlatformName');
        const selectedPlatformId = Cookies.get('selectedPlatformId');
        console.log('selectedPlatformName cookie:', selectedPlatformName);
        console.log('selectedPlatformId cookie:', selectedPlatformId);

        const isPriorityMode = selectedPlatformName === 'Priority';
        console.log('Is Priority Mode:', isPriorityMode);

        // For Priority mode, fetch platforms once to map platformID to names
        let platformMap = {};
        if (isPriorityMode && payloads.length > 0) {
            console.log('=== ENTERING PRIORITY MODE PLATFORM FETCH ===');
            console.log('First payload:', payloads[0]);
            try {
                if (companyID) {
                    console.log('Fetching platforms from API...');
                    const platformsResponse = await axios.get(
                        `/Company/${companyID}/Platforms/Available`,
                    );
                    const platforms = platformsResponse.data;
                    console.log('Available platforms from API:', platforms);

                    platforms.forEach((platform) => {
                        const displayName =
                            platform.name === 'Eightbyeight'
                                ? '8x8'
                                : platform.name;
                        platformMap[platform.id] = displayName;
                        console.log(
                            `Mapping platform - ID: "${platform.id}", Name: "${platform.name}", Display: "${displayName}"`,
                        );
                    });
                    console.log('Platform map:', platformMap);
                    console.log('Platform map keys:', Object.keys(platformMap));
                } else {
                    console.warn('No companyID found in first payload!');
                }
            } catch (e) {
                console.error('Failed to fetch platforms for display:', e);
            }
        } else {
            console.log(
                'NOT in priority mode or no payloads - isPriorityMode:',
                isPriorityMode,
                'payloads.length:',
                payloads.length,
            );
        }

        // Process payloads sequentially with for...of instead of forEach
        for (let index = 0; index < payloads.length; index++) {
            const payload = payloads[index];

            try {
                //api call
                let response;
                if (Cookies.get('selectedPlatformId') === 'numbers') {
                    response = await axios.put('/number/', payload);
                } else {
                    if (payload.trunkName === 'MS Operator Connect') {
                        payload.isConfirmed = true;
                    }
                    response = await axios.put('/PlatformNumber/', payload);
                }

                console.log('API response:', response);

                // Add platform property for Priority mode
                if (isPriorityMode && payload.platformID) {
                    const platformName = platformMap[payload.platformID];
                    console.log(
                        `Looking up platform - platformID: "${payload.platformID}", found: "${platformName}"`,
                    );
                    response.data.platform = platformName || '';
                    console.log(
                        `Added platform to success response - platformID: ${payload.platformID}, platform: ${response.data.platform}`,
                    );
                } else {
                    console.log(
                        'Skipping platform addition - isPriorityMode:',
                        isPriorityMode,
                        'platformID:',
                        payload.platformID,
                    );
                }

                //then store the success response
                responses.push(response);
                console.log('Success response:', response.data);
            } catch (e) {
                console.log('API error for payload:', payload);
                console.log('Error details:', e);
                //put to failed table
                const errorPayload = {
                    ...payload,
                    apiErrors:
                        `${e?.message}\n${e?.response.data?.message}\n${e?.response?.status}` ||
                        ERROR_MESSAGE,
                };

                // Add platform property for Priority mode
                if (isPriorityMode && payload.platformID) {
                    const platformName = platformMap[payload.platformID];
                    console.log(
                        `Looking up platform for error - platformID: "${payload.platformID}", found: "${platformName}"`,
                    );
                    errorPayload.platform = platformName || '';
                    console.log(
                        `Added platform to error - platformID: ${payload.platformID}, platform: ${errorPayload.platform}`,
                    );
                } else {
                    console.log(
                        'Skipping platform addition to error - isPriorityMode:',
                        isPriorityMode,
                        'platformID:',
                        payload.platformID,
                    );
                }

                errors.push(errorPayload);
                console.log('Error payload:', errorPayload);
                //count as error
                setErrorCounter((prev) => prev + 1);
            } finally {
                //set UI counter
                setCounter((prev) => prev + 1);
            }
        }

        // Delete cookies after all processing is complete
        //Cookies.remove('selectedPlatformName');
        Cookies.remove('selectedPlatformId');

        // Set state for Failed & Succeed table
        handleFinishBulkUpdate({ errors, responses });
    };

    /**
     * handle UI button - start api call when payload is ready.
     */
    const handlePayloadChange = useCallback((payloads) => {
        processSubmission(payloads);
    }, []);

    /**
     * handle UI button - export API calls that failed to CSV.
     */
    const handleExportFailedData = () => {
        const failedData = transformJSONData(error);
        const res = Papa.unparse(failedData);
        downloadCSV(
            res,
            buildCompanyFilename(
                currentCompanyData?.name,
                Cookies.get('selectedPlatformName'),
                'Failed',
                'Results',
            ),
        );
    };

    /**
     * handle UI button - export successful API results to CSV.
     */
    const handleExportSucceedData = () => {
        const succeedData = transformJSONData(succeed.map((r) => r.data));
        const res = Papa.unparse(succeedData);
        downloadCSV(
            res,
            buildCompanyFilename(
                currentCompanyData?.name,
                Cookies.get('selectedPlatformName'),
                'Modified',
                'Results',
            ),
        );
    };

    /**
     * transforms JSON Data from BE fields into more human readable CSV heading columns
     * @param {*} data
     * @returns
     */
    const transformJSONData = (data) => {
        return data.map((number) => {
            return Object.keys(API_RESULT_FIELDS_TO_EXPORT).reduce(
                (acc, key) => {
                    const value = number[key];
                    const newKey = API_RESULT_FIELDS_TO_EXPORT[key];
                    acc[newKey] = value;
                    return acc;
                },
                {},
            );
        });
    };

    return {
        handlePayloadChange,
        loading,
        counter,
        errorCounter,
        error,
        succeed,
        handleExportFailedData,
        handleExportSucceedData,
        total: uploadPayloads.length,
    };
}
